export const calculateTotalPosts = (data) => {
  // Sum up all videos across the provided data
  return data.reduce((sum, item) => sum + (item.videos?.length || 0), 0);
};

export const calculateTotalReactions = (data) => {
  // Sum up likes for all videos
  return data.reduce(
    (sum, item) =>
      sum +
      (item.videos?.reduce(
        (videoSum, video) => videoSum + (video.videoMetrics?.likeCount || 0),
        0
      ) || 0),
    0
  );
};

// [NEW] Metrics
export const calculateTotalImpressions = () => 0; // Not available via standard API call used
export const calculateTotalReach = () => 0; // Not available
export const calculateTotalProfileViews = () => 0; // Not available

export const calculateTotalVideoViews = (data) => {
  if (!Array.isArray(data)) return 0;
  // Use analytics views if available, else sum individual video views?
  // Use channelMetrics views (which comes from YT Analytics)
  return data.reduce((sum, item) => sum + (Number(item.channelMetrics?.views) || 0), 0);
};
